var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "area-select-dialog",
        title: "选择地区",
        visible: _vm.orgDialogVisible,
        "before-close": _vm.handleClose,
        modal: _vm.modal,
        "modal-append-to-body": _vm.modalAppendToBody,
        "append-to-body": _vm.appendToBody,
        "lock-scroll": _vm.lockScroll,
        width: "800px",
        center: ""
      },
      on: {
        "update:visible": function($event) {
          _vm.orgDialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _c("div", [
            _c("div", { staticClass: "box-title" }, [_vm._v("可选择列表")]),
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c("left-tree", {
                  ref: "tree",
                  attrs: {
                    "select-id": _vm.rootOrgId,
                    "root-org-id": _vm.rootOrgId
                  },
                  on: { pickNode: _vm.handleNodePick }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "box-title",
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between"
                }
              },
              [
                _c("span", [_vm._v("已选择地区")]),
                _c(
                  "el-button",
                  {
                    staticClass: "btn-info",
                    staticStyle: { padding: "4px 5px", "margin-top": "0px" },
                    style: [
                      {
                        backgroundColor:
                          _vm.pickedNode.length > 0 ? "#d43c3f" : ""
                      },
                      {
                        borderColor: _vm.pickedNode.length > 0 ? "#d43c3f" : ""
                      }
                    ],
                    attrs: { size: "mini" },
                    on: { click: _vm.cleanAll }
                  },
                  [_vm._v("清空 ")]
                )
              ],
              1
            ),
            _c(
              "div",
              {
                key: _vm.pickedNode.length,
                staticClass: "box-content",
                staticStyle: { padding: "10px" }
              },
              _vm._l(_vm.pickedNode, function(node) {
                return _c("div", { key: node.id, staticClass: "picked-item" }, [
                  _vm._v(" " + _vm._s(node.cityName) + " "),
                  _c("i", {
                    staticClass: "el-icon-circle-close icon-close",
                    on: {
                      click: function($event) {
                        return _vm.cleanNode(node)
                      }
                    }
                  })
                ])
              }),
              0
            )
          ])
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function($event) {
                  return _vm.$emit("cancle")
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.confirm }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }